import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { CustomizationFlagQueries } from '@frontend/api-customization-flags';
import { checkAggregateACL } from '@frontend/auth-helpers';
import { useAppScopeStore } from '@frontend/scope';

export const useGetLocationsWithReviewsAnalyticsAccess = () => {
  const { selectedLocationIds } = useAppScopeStore();

  const { locationIdWiseCustomizationFlagDetails } = CustomizationFlagQueries.useAggregateCustomizationFlagDetails({
    locationIds: selectedLocationIds,
    enabled: true,
    customizationFlag: Feature.REVIEWS_HOME_ICON,
  });
  const { aclValuesByLocationId } = checkAggregateACL(selectedLocationIds, [Permission.REVIEW_ANALYTICS_READ]);

  const locationsWithReviewsAnalyticsAccess = selectedLocationIds.filter(
    (location: string) => locationIdWiseCustomizationFlagDetails[location] && aclValuesByLocationId[location]
  );

  return locationsWithReviewsAnalyticsAccess;
};
